import Matching from './Matching.esm.js';
import scoring from './scoring/index.esm.js';
import TimeEstimates from './TimeEstimates.esm.js';
import Feedback from './Feedback.esm.js';
export { default as ZxcvbnOptions } from './Options.esm.js';

const time = () => new Date().getTime();

const zxcvbn = password => {
  const feedback = new Feedback();
  const matching = new Matching();
  const timeEstimates = new TimeEstimates();
  const start = time();
  const matches = matching.match(password);
  const matchSequence = scoring.mostGuessableMatchSequence(password, matches);
  const calcTime = time() - start;
  const attackTimes = timeEstimates.estimateAttackTimes(matchSequence.guesses);
  return {
    calcTime,
    ...matchSequence,
    ...attackTimes,
    feedback: feedback.getFeedback(attackTimes.score, matchSequence.sequence)
  };
};

export { zxcvbn };
//# sourceMappingURL=index.esm.js.map
